import api from "../apiConfig";
import paramsFactory from "../../utils/paramsFactory";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  index(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/crm-lead?${p}`);
  },
  showById(id) {
    return api.get(`/api/v1/crm-lead/${id}`);
  },
  create(data) {
    return api.post(`/api/v1/crm-lead`, data);
  },
  update(id, data) {
    return api.put(`/api/v1/crm-lead/${id}`, data);
  },
  delete(id) {
    return api.delete(`/api/v1/crm-lead/${id}`);
  },
  getEnums() {
    return api.get(`/api/v1/crm-lead/enums`);
  },
  getGovernances() {
    return api.get(`/api/v1/governance`);
  },
  changeStatus(id, data) {
    return api.post(`/api/v1/crm-lead/${id}/change-status`, data);
  },
  addComment(id, data) {
    return api.post(`/api/v1/crm-lead/${id}/comment`, data);
  },
  exportToExcel(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/crm-lead?${p}`, {
      responseType: "blob",
    });
  },
};
